const { OfferServiceConnector } = require('./OfferServiceConnector');
const { BookingChannelQueryConnector } = require('./BookingChannelQueryConnector');
const { BookingQueryConnector } = require('./BookingQueryConnector');
const { CouponServiceConnector } = require('./CouponServiceConnector');
const { DriverStatusServiceConnector } = require('./DriverStatusServiceConnector');
const { FleetQueryConnector } = require('./FleetQueryConnector');
const { PayoutQueryConnector } = require('./PayoutQueryConnector');
const { StripeProxyConnector } = require('./StripeProxyConnector');
const { StripeReconciliationConnector } = require('./StripeReconciliationConnector');
const { BookingIntegrityServiceConnector } = require('./BookingIntegrityServiceConnector');
const { BookingCommandConnector } = require('./BookingCommandConnector');
const { BookingHistoryConnector } = require('./BookingHistoryConnector');
const { BusinessUserServiceConnector } = require('./BusinessUserServiceConnector');
const { ReceiptSenderServiceConnector } = require('./ReceiptSenderServiceConnector');
const { EmployeeServiceConnector } = require('./EmployeeServiceConnector');
const { UserServiceConnector } = require('./UserServiceConnector');
const { NotificationServiceConnector } = require('./NotificationServiceConnector');
const { PaymentServiceConnector } = require('./PaymentServiceConnector');
const { DispatchConnector } = require('./DispatchConnector');

module.exports = {
  DispatchConnector,
  OfferServiceClient: OfferServiceConnector,
  BookingChannelQueryClient: BookingChannelQueryConnector,
  BookingQueryClient: BookingQueryConnector,
  FleetQueryClient: FleetQueryConnector,
  CouponServiceClient: CouponServiceConnector,
  DriverStatusServiceClient: DriverStatusServiceConnector,
  PayoutQueryClient: PayoutQueryConnector,
  StripeProxyClient: StripeProxyConnector,
  StripeReconciliationClient: StripeReconciliationConnector,
  BookingIntegrityServiceClient: BookingIntegrityServiceConnector,
  BookingCommandClient: BookingCommandConnector,
  BookingHistoryClient: BookingHistoryConnector,
  ReceiptSenderServiceClient: ReceiptSenderServiceConnector,
  EmployeeServiceClient: EmployeeServiceConnector,
  UserServiceClient: UserServiceConnector,
  NotificationServiceClient: NotificationServiceConnector,
  PaymentServiceClient: PaymentServiceConnector,
  BusinessUserServiceClient: BusinessUserServiceConnector,
};
